import React from 'react';
import { Box, Typography } from '@mui/material';
import { UserAvailability } from 'core/interfaces/userInterface';
import {
	WeekDay,
	getAvailabilityTimeLabel,
	getLatestAvailabilityForDay,
} from '../../utils/availabilityDisplay';

interface CurrentAvailabilityListProps {
	days: WeekDay[];
	currentAvailability: UserAvailability[];
	subtitle?: string;
}

const CurrentAvailabilityList: React.FC<CurrentAvailabilityListProps> = ({
	days,
	currentAvailability,
	subtitle = 'Your existing availability schedule',
}) => {
	const hasAnyAvailabilityInWeek = currentAvailability.length > 0;

	return (
		<Box sx={{ mb: 3 }}>
			<Typography variant="h6" gutterBottom>
				Current Availability
			</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
				{subtitle}
			</Typography>
			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: {
						xs: 'repeat(2, minmax(0, 1fr))',
						sm: 'repeat(4, minmax(0, 1fr))',
						md: 'repeat(7, minmax(0, 1fr))',
					},
					gap: 1,
				}}
			>
				{days.map((day, index) => {
					const latestAvail = getLatestAvailabilityForDay(currentAvailability, day);
					const { label, kind } = getAvailabilityTimeLabel(
						latestAvail,
						hasAnyAvailabilityInWeek
					);

					return (
						<Box
							key={day['@id'] || index}
							sx={{
								minWidth: 0,
								px: 1,
								py: 1,
								borderRadius: '8px',
								border: '1px solid',
								borderColor:
									kind === 'unavailable'
										? '#ef9a9a'
										: kind === 'unset'
											? '#d5dde7'
											: '#dbe3ee',
								backgroundColor:
									kind === 'unavailable'
										? '#fff5f5'
										: kind === 'unset'
											? '#f7f9fc'
											: '#fff',
							}}
						>
							<Typography
								sx={{
									fontFamily: 'Gotham, sans-serif',
									fontSize: 11,
									fontWeight: 600,
									color: '#6b7789',
									mb: 0.25,
								}}
							>
								{day.label.slice(0, 3)}
							</Typography>
							<Typography
								sx={{
									fontFamily: 'Gotham, sans-serif',
									fontSize: 12,
									fontWeight: 500,
									lineHeight: 1.3,
									color:
										kind === 'unavailable'
											? '#c62828'
											: kind === 'unset'
												? '#6b7789'
												: '#1c1b1c',
								}}
							>
								{label}
							</Typography>
						</Box>
					);
				})}
			</Box>
		</Box>
	);
};

export default CurrentAvailabilityList;
